export default __webpack_public_path__ + "static/media/thumbnail.f5628f8d.png";